import SEO from "../../../../../src/components/Seo";
import SyntaxHighlighter from 'react-syntax-highlighter';
import * as React from 'react';
export default {
  SEO,
  SyntaxHighlighter,
  React
};